export default "__VITE_PUBLIC_ASSET__2cab2efe__"